<tpm-card
  rounded-8
  class="module-card"
  variant="elevation-basic-20"
  (click)="props.active && onClick({ event: $event, value: props.name, eventEmitter: moduleCardClicked })"
>
  <div
    class="module-card-container"
    [class.module-card-container--mobile]="isMobile"
    [class.module-card-container--disabled]="!props.active"
  >
    <div *ngIf="!isMobile" class="module-card__module-logo-container">
      <img class="module-logo" [ngSrc]="props.icon!" fill />
      <div class="lock-icon-container">
        <tpm-icon *ngIf="!props.active" class="lock-icon" [icon]="'gpi-lock-alt'"></tpm-icon>
      </div>
    </div>
    <div *ngIf="!isMobile" class="module-card__provider-logo-container">
      <img class="provider-logo" [ngSrc]="props.logo" fill />
    </div>
    <h1 class="module-card__heading" [class.module-card__heading--disabled]="!props.active">{{ props.title }}</h1>
    <div class="module-card__body">
      <ng-container *ngIf="props.active && !!newsProps; else defaultTempl">
        <tpm-inner-news-card
          [props]="newsProps"
          (clicked)="onClick({ event: null, value: $any($event), eventEmitter: innerNewsCardButtonClicked })"
        ></tpm-inner-news-card>
      </ng-container>
      <ng-template #defaultTempl>
        <div class="module-card__body__description-container">
          <p class="body-md">{{ props.description }}</p>
          <button
            *ngIf="$any(props).showStoryTellerButton"
            launchpadIconButton
            ene-button
            class="storyteller-button"
            color="primary"
            icon="gpi-listen"
            size="xlarge"
            [disabled]="!props.active"
            (click)="onClick({ event: $event, value: props.name, eventEmitter: storytellerButtonClicked })"
          ></button>
        </div>
        <button
          *ngIf="$any(props).showLeadButton"
          launchpadButton
          ene-outline-button
          rightIcon
          class="lead-button"
          icon="ec_controls_collapsed_dropdown"
          color="primary"
          size="xlarge"
          (click)="onClick({ event: $event, value: props.name, eventEmitter: leadButtonClicked })"
        >
          {{ "APP.INFORM_NOW" | translate }}
        </button>
        <button
          *ngIf="$any(props).showProductManagementButton"
          launchpadButton
          ene-outline-button
          rightIcon
          class="product-management-button"
          icon="ec_controls_collapsed_dropdown"
          color="primary"
          size="xlarge"
          (click)="onClick({ event: $event, value: props.name, eventEmitter: productButtonClicked })"
        >
          {{ "APP.PRODUCT_MANAGEMENT" | translate }}
        </button>
        <h3 *ngIf="$any(props).showInProgress" class="in-progress-status">{{ "APP.IN_PROGRESS" | translate }}</h3>
      </ng-template>
    </div>
  </div>
</tpm-card>
